import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import {
  MatOption
} from '@angular/material/select';
import { IFiber } from '@rfm/shared-interfaces';
import { BlockUI, BlockUIModule, NgBlockUI } from 'ng-block-ui';
import { FiberService } from '../../../shared/services/fiber-management/fiber.service.mjs';
import { DialogData } from '../map.component';

@Component({
    selector: 'app-fiber-map-dialog',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        CommonModule,
        BlockUIModule,
    ],
    templateUrl: './fiber-map-dialog.component.html',
    styleUrl: './fiber-map-dialog.component.scss'
})
export class FiberMapDialogComponent {
  @BlockUI() blockUI!: NgBlockUI;

  type: string = '';
  mapData: any;
  categories: MatOption[] = [];

  fiberForm = this.formBuilder.group({
    id: '',
    name: '',
    type: '',
    count: 0,
    category: '',
    note: '',
  });

  close() {
    this.dialogRef.close(true);
  }

  async onSubmit() {
    const newFiber: IFiber = {
      id: '',
      createdAt: 0,
      createdBy: '',
      name: this.fiberForm.value.name ?? '',
      type: this.fiberForm.value.type ?? '',
      category: this.fiberForm.value.category ?? '',
      count: this.fiberForm.value.count ?? 0,
      buryType: '',
      updatedAt: 0,
      updatedBy: ''
    };

    await this.fiberService.insert(newFiber).then(() => {
      this.dialogRef.close();
    });
  }

  constructor(
    private fiberService: FiberService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<FiberMapDialogComponent>
  ) {
    this.type = this.data.type;
    this.mapData = this.data.mapData;

    console.log(this.mapData);

    this.categories.push({ value: 'trunk', viewValue: 'Trunk' } as MatOption);
    this.categories.push({
      value: 'sub-trunk',
      viewValue: 'Sub Trunk',
    } as MatOption);
    this.categories.push({
      value: 'homedrop',
      viewValue: 'Home Drop',
    } as MatOption);
  }
}
